import { createFileRoute, redirect } from "@tanstack/react-router";

// Standalone vendor portal: there is no admin login here. Keep the /login
// route registered (shared auth components link to it) but bounce it to the
// vendor login, which dispatches against the vendor backend (authLoginVendor).
export const Route = createFileRoute("/login")({
  // Kept for the shared LoginContainer's useSearch() type; the route never
  // actually renders because beforeLoad redirects first.
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect:
      typeof search.redirect === "string" && search.redirect.length > 0 && search.redirect.startsWith("/")
        ? search.redirect
        : undefined,
  }),
  beforeLoad: () => {
    throw redirect({ to: "/vendor/login" });
  },
});
